import { Navigate } from 'react-router-dom';

import { useFeatures } from '@/hooks/useFeatures';
import { FeaturesConfig } from '@/lib/api/features';

interface FeatureGateProps {
  featureKey: keyof FeaturesConfig;
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * Guards routes based on feature flags
 * Redirects to specified path if feature is disabled
 */
export function FeatureGate({
  featureKey,
  children,
  redirectTo = '/dashboard'
}: FeatureGateProps) {
  const { features, loading } = useFeatures();

  // Show nothing while loading to prevent flash
  if (loading) {
    return null;
  }

  // If feature is disabled, redirect
  if (!features[featureKey]) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
